import { render, staticRenderFns } from "./PopupNotice.vue?vue&type=template&id=09e21f1a"
import script from "./PopupNotice.ts?vue&type=script&lang=js&external"
export * from "./PopupNotice.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports